<template>
<div class="main">
  <div class="sidebar">
    <v-sidebar></v-sidebar>
  </div>
  <div class="content-box">
    <router-view/>
  </div>
</div>
</template>

<script>
import vSidebar from '../../components/ssp/account/pSidebar.vue'
    export default {
        components:{
            vSidebar
        }
    }
</script>

<style>
</style>
